import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import GraphQL from '../../GraphQL';
import SmartCard from '../../shared/components/SmartCard';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import { responsibleSaveMutation } from '../../shared/queries/Responsible';
import ResponsibleForm from './components/Form';

const ResponsibleFormHandler = (props) => {
  const { match, t, history, dispatch } = props;
  const [formOn, setFormOn] = useState(false);
  const [email, setEmail] = useState('0');

  function backClickHandler() {
    history.push('/minime/responsavel');
  }

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const saveData = (values) => {
    showLoading();
    const mutationQuery = responsibleSaveMutation(values, true);
    GraphQL(mutationQuery, {
      firstName: values.firstName,
      lastName: values.lastName,
      fullName: values.fullName,
    })
      .then(() => {
        hideLoading();
        backClickHandler();
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-saved')
        );
      })
      .catch(() => {
        hideLoading();
      });
  };

  const handleSubmit = (values) => {
    if (values.relatedStudents.length) {
      if (
        values.relatedStudents.some((students) => students.financialContact)
      ) {
        if (!values.cpf || !values.zipCode) {
          showNotificationAutoDestroy(
            'warning',
            t('notifications.attention'),
            t('notifications.warning-no-documents')
          );
        } else {
          saveData(values);
        }
      } else {
        saveData(values);
      }
    } else {
      showNotificationAutoDestroy(
        'warning',
        t('notifications.attention'),
        t('notifications.no-related-students')
      );
    }
  };

  useEffect(() => {
    if (match.params.email && match.params.email !== '0') {
      if (email !== match.params.email) {
        setEmail(match.params.email);
        setFormOn(true);
      } else {
        setFormOn(true);
      }
    } else {
      setFormOn(true);
    }
  }, []);

  return (
    <SmartCard title={t('panels.responsavel')}>
      {formOn ? (
        <ResponsibleForm
          onSubmit={handleSubmit}
          backHandler={backClickHandler}
          showLoading={showLoading}
          hideLoading={hideLoading}
          selectedEmail={email}
        />
      ) : null}
    </SmartCard>
  );
};

ResponsibleFormHandler.propTypes = {
  t: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(ResponsibleFormHandler)
);
